module.exports = __webpack_public_path__ + "d47a692dc10c9ea78d257fa5fe6dc71d.svg";